import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';

import { AppUtilityService } from './../../../core/services/app-utility.service';
import { ConfigService } from './../../../core/services/config.service';
import { LmsModuleService } from './../../../core/services/lms-module.service';
import { OutlyingPoint } from './../../../core/model/outlying-point.model';
import { OutlyingPointResponse } from '../../../core/model/outlying-point-response.model';
import { SelectItem } from 'primeng/api/selectitem';
import { Tab } from './../../../core/model/tab.model';
import { UtilService } from './../../../core/services/util.service';

/**
 * @export
 * @class OutlyingPointHeaderComponent
 * @implements {OnInit}
 * @implements {OnChanges}
 */
@Component({
  selector: 'lms-outlying-point-header',
  templateUrl: './outlying-point-header.component.html',
  styleUrls: ['./outlying-point-header.component.scss']
})
export class OutlyingPointHeaderComponent implements OnInit, OnChanges {

  @Input() spinnerVal; // This is the spinner value of Tab
  @Input() tab: Tab; // This is Selected Tab
  @Input() oulyingData: OutlyingPointResponse; // Original Response of Outlying Point
  @Output() updatedOutlyingList: EventEmitter<Array<OutlyingPoint>> = new EventEmitter<Array<OutlyingPoint>>(); // Emitter to emit changed list to be displayed
  spinnerValueOptions: SelectItem[]; // Drop down of Spinner
  spinnerValues: any; // Spinner Values
  displayType: string; // Model to link filter
  outlyingDataLabel: any; // Get Outyling Data label from Config Service;
  tabLevel: number;

  constructor(private utilService: UtilService, private configService: ConfigService, private lmsModuleService: LmsModuleService, public appUtilityService: AppUtilityService) {
    this.outlyingDataLabel = this.configService.getConfigData().outlyingPointLabel;
    this.tabLevel = this.configService.getConfigData().tabIndex.subTabs;
  }

  /**
   * @memberof OutlyingPointHeaderComponent
   */
  ngOnInit() {
    this.spinnerValueOptions = [];
    this.displayType = this.outlyingDataLabel.WTL;
    this.spinnerValues = this.configService.getConfigData().spinnerValue.values;
    for (let i = 0; i < this.spinnerValues.length; i++) {
      this.spinnerValueOptions.push({
        label: this.spinnerValues[i].label,
        value: this.spinnerValues[i].value
      });
    }
  }

  /**
   * @memberof OutlyingPointHeaderComponent
   */
  ngOnChanges() {
    this.displayType = this.outlyingDataLabel.WTL;
    this.getValueForDisplayType(this.displayType);
  }

  /**
   * This method filter the list according to filter provided above
   * @param {string}
   * @memberof OutlyingPointHeaderComponent
   */
  public getValueForDisplayType(type: string) {
    if (this.oulyingData) {
      let oulyingDataDisplay: Array<OutlyingPoint>;
      if (this.outlyingDataLabel.WTL === type) {
        oulyingDataDisplay = this.oulyingData.outlyingPointWithTrainAndTerminal;
        this.updatedOutlyingList.emit(oulyingDataDisplay);
      } else if (this.outlyingDataLabel.WOTL === type) {
        oulyingDataDisplay = this.oulyingData.outlyingPointWithoutTrainAndTerminal;
        this.updatedOutlyingList.emit(oulyingDataDisplay);
      } else if (this.outlyingDataLabel.ALL === type) {
        oulyingDataDisplay = this.oulyingData.outlyingPoint;
        this.updatedOutlyingList.emit(oulyingDataDisplay);
      }
    }
  }

  /**
   * This method push the elements inside array
   * @private
   * @param {OutlyingPoint} rowData
   * @returns {Array<string>}
   * @memberof OutlyingPointHeaderComponent
   */
  private pushValueInArray(rowData: OutlyingPoint): Array<string> {
    const gridValueString: Array<string> = [];
    gridValueString.push(rowData.terminatingTrains);
    gridValueString.push(rowData.terminatingLocos);
    gridValueString.push(rowData.originatingTrains);
    gridValueString.push(rowData.originatingLocos);
    gridValueString.push(rowData.roadLocos);
    gridValueString.push(rowData.yardLocalLocos);
    gridValueString.push(rowData.mowLocos);
    gridValueString.push(rowData.totalLocosOnTerm);
    return gridValueString;
  }

  /**
   * Check whether all fields are blank or not
   * @private
   * @param {string[]} value
   * @returns
   * @memberof OutlyingPointHeaderComponent
   */
  private checkMultipleBlankValues(value: string[]) {
    let isBlank: boolean;
    for (let i = 0; i < value.length; i++) {
      if (value[i] && this.outlyingDataLabel.threeZero !== value[i]) {
        isBlank = false;
        break;
      } else {
        isBlank = true;
      }
    }
    return isBlank;
  }

  /**
   * Refresh page when spinner value is changed
   * @memberof OutlyingPointHeaderComponent
   */
  public changeSpinnerValue() {
    const tab: Tab = this.utilService.deepClone(this.tab);
    tab.tabSearchParameter.spinnerVal = this.spinnerVal;
    tab.subTypeDetail[tab.subType.toLowerCase()].status = this.configService.getConfigData().tabStatus.refresh;
    this.lmsModuleService.updateSelectedTab(tab);
  }



}

